import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsBackgroundBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsBackgroundBlockEntity
